import * as React from "react";

const variants = {
  error: "border-red-200 bg-gradient-to-br from-red-50 to-white text-red-900 shadow-[inset_0_1px_0_rgba(255,255,255,0.7)]",
  success:
    "border-emerald-200 bg-gradient-to-br from-emerald-50 to-white text-emerald-900 shadow-[inset_0_1px_0_rgba(255,255,255,0.7)]",
  warning:
    "border-amber-200 bg-gradient-to-br from-amber-50 to-white text-amber-900 shadow-[inset_0_1px_0_rgba(255,255,255,0.7)]",
  info: "border-slate-200 bg-gradient-to-br from-slate-50 to-white text-slate-900 shadow-[inset_0_1px_0_rgba(255,255,255,0.7)]",
};

export default function Alert({ title, children, variant = "info" }) {
  return (
    <div className={`rounded-xl border px-3 py-2 ${variants[variant]}`}>
      {title && <p className="text-xs font-semibold tracking-tight">{title}</p>}
      {children && <p className="mt-0.5 text-xs leading-4 opacity-90">{children}</p>}
    </div>
  );
}
